import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenAddress',
  standalone: true,
})
export class ShortenAddressPipe implements PipeTransform {
  /**
   * Shortens a blockchain address to a readable format
   * @param value The full address (e.g., "0xAb5801a7D398351b8bE1198666E10e7f3b4A4b71")
   * @param startChars Number of characters to show at the start (default: 8)
   * @param endChars Number of characters to show at the end (default: 6)
   * @returns Shortened address (e.g., "0xAb5801…4A4b71")
   */
  transform(
    value: string | undefined | null,
    startChars: number = 8,
    endChars: number = 6
  ): string {
    if (!value) return 'N/A';

    const minLength = startChars + endChars;
    if (value.length <= minLength) return value;

    return `${value.substring(0, startChars)}…${value.substring(value.length - endChars)}`;
  }
}
